exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-issuance/upload-issuance-hasil/upload-issuance-hasil.component.css
// module id = ../../../../../src/app/upload-issuance/upload-issuance-hasil/upload-issuance-hasil.component.css
// module chunks = 1